  window.VocalShopKits = window.VocalShopKits || {};
  (function () {
    const DEBUG = false;

    function log(...args) {
      if (DEBUG) console.log("[VocalShop Kit Engine]", ...args);
    }

    function getCurrentKitConfig() {
      return (
        window.VOCALSHOP_CURRENT_KIT ||
        window.VOCALSHOP_KIT_CONFIG ||
        null
      );
    }

    function normalizeComponent(component) {
      return {
        handle: component.handle,
        variantId: Number(
          component.variantId ||
          component.defaultVariantId ||
          component.id
        ),
        quantity: Number(component.quantity || 1),
        subscription: Boolean(component.subscription),
        defaultSellingPlanId: component.defaultSellingPlanId
          ? Number(component.defaultSellingPlanId)
          : null,
        properties: component.properties || {}
      };
    }

    async function fetchProduct(handle) {
      const response = await fetch(`/products/${handle}.js`, {
        credentials: "same-origin",
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error(`Could not fetch product: ${handle}`);
      }

      return response.json();
    }

    function findVariant(product, variantId) {
      const variant = product.variants.find(function (variant) {
        return Number(variant.id) === Number(variantId);
      });

      if (!variant) {
        throw new Error(
          `Variant ${variantId} not found on product ${product.handle}`
        );
      }

      return variant;
    }

    function resolveSellingPlan(component, variant, subscribe) {
      if (!subscribe || !component.subscription) return null;

      const allocations = variant.selling_plan_allocations || [];

      if (!allocations.length) {
        log("No selling plan allocations for variant", variant.id);
        return null;
      }

      if (component.defaultSellingPlanId) {
        const matchingAllocation = allocations.find(function (allocation) {
          return (
            Number(allocation.selling_plan_id) ===
            Number(component.defaultSellingPlanId)
          );
        });

        if (matchingAllocation) {
          return Number(matchingAllocation.selling_plan_id);
        }
      }

      return Number(allocations[0].selling_plan_id);
    }

async function buildCartItem(component, options) {
  const normalized = normalizeComponent(component);
  const product = await fetchProduct(normalized.handle);
  const variant = findVariant(product, normalized.variantId);

  if (!variant.available) {
    throw new Error(`${product.title} is currently out of stock`);
  }

  const sellingPlanId = resolveSellingPlan(
    normalized,
    variant,
    options.subscribe
  );

  const item = {
    id: normalized.variantId,
    quantity: normalized.quantity
  };

  if (sellingPlanId) {
    item.selling_plan = sellingPlanId;
  }

  if (normalized.properties && Object.keys(normalized.properties).length) {
    item.properties = normalized.properties;
  }

  return item;
}

    async function addItemsToCart(items) {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Could not add kit to cart");
      }

      return response.json();
    }

    function getDiscountCode(kitConfig, subscribe) {
      if (!kitConfig) return null;

      if (subscribe) {
        return (
          kitConfig.subscriptionDiscountCode ||
          kitConfig.kitSubscriptionDiscountCode ||
          kitConfig.discounts?.subscription ||
          null
        );
      }

      return (
        kitConfig.discountCode ||
        kitConfig.kitDiscountCode ||
       kitConfig.discounts?.oneTime ||
        null
      );
    }

    function redirectAfterAdd(kitConfig, subscribe) {
      const discountCode = getDiscountCode(kitConfig, subscribe);

      if (discountCode) {
        window.location.href =
          `/discount/${encodeURIComponent(discountCode)}?redirect=/cart`;
        return;
      }

      window.location.href = "/cart";
    }

    async function addKit(options) {
      const opts = options || {};
      const kitConfig = opts.kitConfig || getCurrentKitConfig();

      if (!kitConfig) {
        throw new Error("No VocalShop kit config found on this page");
      }

      const components =
        kitConfig.components ||
        kitConfig.kitComponents ||
        kitConfig.items ||
        [];

      if (!Array.isArray(components) || !components.length) {
        throw new Error("No kit components found");
      }

      const subscribe = Boolean(opts.subscribe);

      log("Adding kit", { subscribe, components });

      const items = await Promise.all(
        components.map(function (component) {
          return buildCartItem(component, { subscribe: subscribe });
        })
      );

      await addItemsToCart(items);

      if (opts.redirect === false) {
        return { ok: true, items: items };
      }

      redirectAfterAdd(kitConfig, subscribe);

      return { ok: true, items: items };
    }

    function setButtonLoading(button, loading) {
      if (!button) return;

      if (loading) {
        button.dataset.originalText = button.textContent;
        button.disabled = true;
        button.textContent = "Adding...";
      } else {
        button.disabled = false;
        if (button.dataset.originalText) {
          button.textContent = button.dataset.originalText;
        }
      }
    }

    async function handleButtonClick(event) {
      const button = event.target.closest("[data-vocalshop-kit-action]");
      if (!button) return;

      event.preventDefault();

      const action = button.dataset.vocalshopKitAction;
      const subscribe = action === "subscribe";

      try {
        setButtonLoading(button, true);
        await addKit({ subscribe: subscribe });
      } catch (error) {
        console.error("[VocalShop Kit Engine]", error);
        setButtonLoading(button, false);
        alert("Sorry — something went wrong adding this kit to cart.");
      }
    }

    document.addEventListener("click", handleButtonClick);

    window.VocalShopKits.addKit = addKit;
    window.VocalShopKits.fetchProduct = fetchProduct;
    window.VocalShopKits.buildCartItem = buildCartItem;
    window.VocalShopKits.version = "2026-05-11-simplified";
  })();